import { Card, ConfigProvider, Divider, Flex, Typography } from 'antd';
import { useTheme } from '../../../context/ThemeContext';
import Icon from '@ant-design/icons';
import { ReactComponent as DriverDetailsBlackSvg } from '../../../assets/driver-details-black.svg';
import { ReactComponent as DriverDetailsSvg } from '../../../assets/driver-details-white.svg';
import { DARK, HYPHEN } from '../../../utilities/constants';
import PropTypes from 'prop-types';

const { Text } = Typography;
const DriverDetails = ({ selectedTripDetails }) => {
  const { theme } = useTheme();

  return (
    <ConfigProvider
      theme={{
        components: {
          Card: {
            padding: 0,
            paddingLG: 0,
            headerBg: 'var(--secondary-fill-color, #2E3033)',
            colorBorderSecondary: theme === DARK ? '#2E3033' : '#E0E2E5',
            colorBgContainer: theme === DARK ? '#2E3033' : '#E0E2E5',
            boxShadowTertiary: 'none',
          },
          Divider: {
            margin: '6px',
            marginLG: '6px',
            marginXL: '6px',
            colorSplit: '#71767C',
          },
          Typography: {
            fontSize: '0.875rem',
          },
        },
      }}
    >
      <Card size="small" variant="borderless">
        <Flex vertical gap={4}>
          <Flex gap={6} align="center">
            <Icon
              component={
                theme === DARK ? DriverDetailsSvg : DriverDetailsBlackSvg
              }
              className="title-icon"
            />

            <Text strong className="title-text">
              Driver Info
            </Text>
          </Flex>
          <Divider />
          <Flex justify="space-between" gap={10}>
            <Text style={{ flexShrink: 0 }}> Name</Text>
            <Text
              strong
              ellipsis={{ tooltip: selectedTripDetails?.driver_name }}
            >
              {selectedTripDetails?.driver_name || HYPHEN}
            </Text>
          </Flex>
        </Flex>
      </Card>
    </ConfigProvider>
  );
};

DriverDetails.propTypes = {
  selectedTripDetails: PropTypes.object,
};

export default DriverDetails;
